<template>
  <div class="bank_body">
    <!--    <m-audio :show-duration="false" text="点这里播放" src="/bofang.png"></m-audio>-->

    <div class="tupian">
      <img :src="tupian">
    </div>
    <!--    <div class="xianshi">限时福利！立减20元</div>-->
    <van-tabs v-model="activeName">
      <van-tab name="b" title="课程列表">
        <van-collapse v-model="value">
          <van-collapse-item name="1" title="视频目录">
            <van-empty v-if="this.listsp==null || this.listsp.length==0" description="暂无视频，敬请期待！"/>
            <div v-for="(item,index) in listsp" class="shiping"
                 style="border-bottom: #f5f2f2 1px solid;padding-bottom: 6px">
              <div class="xiabiao" style="width: 15px">{{ index + 1 }}</div>
              <div class="kecheng" style=";overflow: hidden;text-overflow:ellipsis;white-space: nowrap;width: 50%">
                {{ item.titles }}
              </div>
              <div v-if="item.types==0" style="color: #FF00FF;position: absolute;right: 20%">正在学习</div>
              <div v-if="item.types==1" style="color:  #D9D9F3;position: absolute;right: 20%">已学习</div>
              <div class="bofang" @click="shiping(item)">
                <img v-if="item.ivs==1 " src="/bofang.png">
                <img v-if="item.ivs==0 " src="/suo.png">
              </div>
            </div>
          </van-collapse-item>
          <van-collapse-item name="2" title="音频文件">
            <van-empty v-if="this.yp==null || this.yp.length==0" description="暂无音频，敬请期待！"/>
            <div v-for="(item,index) in yp" class="shiping">
              <div class="xiabiao">{{ index + 1 }}</div>
              <div class="kecheng">{{ item.titles }}</div>
              <div class="bofang" @click="yinping(item,'yp')">
                <img v-if="item.ivs==1 || statuse==1" src="/bofang.png">
                <img v-if="item.ivs==0 && statuse==0" src="/suo.png">
              </div>
            </div>
          </van-collapse-item>
          <van-collapse-item name="3" title="图片文件">
            <van-empty v-if="tp==null || tp.length==0" description="暂无图片，敬请期待！"/>
            <div v-for="(item,index) in tp" class="shiping">
              <div class="xiabiao">{{ index + 1 }}</div>
              <div class="kecheng">{{ item.titles }}</div>

              <div class="preview"><img :src="item.url" @click="imgPre(item.url)"/></div>

              <div class="bofang" @click="tpimg(tp[index].url)">

                <img v-if="!item.url" src="/suo.png">
                <!--                <img v-if="item.ivs==1 || statuse==1" src="/bofang.png">-->
                <!--                <img v-if="item.ivs==0 && statuse==0" src="/suo.png">-->
              </div>
            </div>
          </van-collapse-item>
          <van-collapse-item name="4" title="跟唱文件">
            <van-empty v-if="this.gc==null || this.gc.length==0" description="暂无跟唱，敬请期待！"/>
            <div v-for="(item,index) in gc" class="shiping">
              <div class="xiabiao">{{ index + 1 }}</div>
              <div class="kecheng">{{ item.titles }}</div>
              <div class="bofang" @click="yinping(item,'gc')">
                <img src="/bofang.png">
                <!--                <img v-if="item.ivs==0 && statuse==0" src="/suo.png">-->
              </div>
            </div>
          </van-collapse-item>
          <van-collapse-item name="5" title="伴奏文件">
            <van-empty v-if="this.gc==null || this.gc.length==0" description="暂无跟唱，敬请期待！"/>
            <div v-for="(item,index) in bzlist" class="shiping">
              <div class="xiabiao">{{ index + 1 }}</div>
              <div class="kecheng">{{ item.titles }}</div>
              <div class="bofang" @click="yinping(item,'bz')">
                <img v-if="item.ivs==0 && statuse==0" src="/suo.png">
                <img v-else src="/bofang.png">
              </div>
            </div>
          </van-collapse-item>
          <div class="button">
            <div class="line"></div>
            <span class="start" @click="start">
              <img src="../../assets/ly.png" width="30"/>
              {{ recorder_status }}
            </span>
            <span :class="{'disabled':notCommit}" class="stop" @click="stop">
              <img alt="" src="../../assets/stop.png" width="30">
              {{ stop_status }}
            </span>
          </div>
        </van-collapse>
      </van-tab>
      <van-tab name="a" title="课程详情">
        <div class="kechengxiangqing">
          <dl>
            <dt>{{ biaoti }}</dt>
            <dd>老师：{{ laoshi }} | 有效期：{{ zhuangtai != 2 ? '' : youxiaoqi + '天' }} | {{ renshu }}人已购买</dd>
            <dd><span>￥</span>{{ jine }} <span>{{ zhuangtai != 2 ? '' : '（看完视频获得永久版权）' }}</span></dd>
            <dd><span>原价￥</span>{{ yuanjia }}</dd>
            <dd>{{ jieshao }}</dd>
          </dl>
          <!--          <div>-->
          <!--            <van-button type="primary" size="small" @click="goumai">购买</van-button>-->
          <!--          </div>-->
        </div>
        <!--        <div v-html="neirong">{{neirong}}</div>-->
        <div style="width: 100%;height: 9px;background:#f8f8f8; "></div>
        <div class="xiangqing">课程简介</div>
        <!--        <div class="xi">黄梅戏与京剧、越剧、评剧 、豫剧并称“中国五大戏曲剧种”，也是安徽省的主要地方戏曲剧种，湖北、江西、福建、浙江、江苏、香港、-->
        <!--          台湾等地亦有黄梅戏的专业或业余的演出团体，-->
        <!--          受到广泛的欢迎-->
        <!--        </div>-->
        <!--        <div class="xiangqingtu" v-for="item in 5">-->
        <!--          <img src="/6.jpeg">-->
        <!--        </div>-->
        <div class="xi" v-html="neirong">{{ neirong }}</div>
      </van-tab>
      <van-tab name="c" title="评论列表">
        <van-empty v-if="this.pjlists==null || this.pjlists.length==0" description="暂时没有人评论！"/>
        <div v-for="item in pjlists" class="pinglun" style="border-bottom: #e8e8e8 1px solid">
          <div class="touxiang"><img :src="item.avatar"></div>
          <div class="neirong">
            <div class="name">{{ item.nickname }}</div>
            <div class="ping">{{ item.contents }}</div>
            <div class="shijian">{{ item.addtime }}</div>
          </div>
        </div>
        <!--        <div class="foot">-->
        <!--          <div class="shuru">-->
        <!--            <van-cell-group>-->
        <!--              <van-field v-model="inputt" placeholder="说点你的心得吧"/>-->
        <!--            </van-cell-group>-->
        <!--          </div>-->
        <!--          <div class="anniu">-->
        <!--            <van-button type="primary" size="small">发送</van-button>-->
        <!--          </div>-->
        <!--        </div>-->
      </van-tab>

    </van-tabs>


    <van-goods-action v-if="this.statuse==0">
      <!--      <van-goods-action-icon icon="chat-o" text="客服" @click="onClickIcon" />-->
      <van-goods-action-icon v-show="!givesize" icon="thumb-circle-o" text="点赞" @click="praise"/>
      <van-goods-action-icon v-show="givesize" icon="thumb-circle" text="已点赞" @click="praise"/>


      <van-goods-action-icon icon="gold-coin-o" text="打赏" @click="reward"/>


      <van-goods-action-button text="加入收藏" type="warning" @click="onClickIcon"/>
      <van-goods-action-button text="立即购买" type="danger" @click="onClickButton"/>

    </van-goods-action>

    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>

        <img id="bgi" src="../../assets/bgi.jpg">
        <ul>
          <li>
            <span>标题：</span>
            <input v-model="upfilename" type="text"/>
          </li>
        </ul>

        <div class="score">
          <img alt="" src="../../assets/score_level.png">
          <div>恭喜您获得{{ score }}分</div>
        </div>

        <div class="button">
          <span class="line"></span>
          <span class="cancel" @click="cancle">取消</span>
          <span class="commit" @click="update">确定</span>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {ImagePreview, Toast} from 'vant';
import wx from 'weixin-js-sdk'
import Recorder from 'js-audio-recorder'
import axios from "axios";


export default {
  name: "bank",
  data() {
    return {
      bzlist:[],
      activeName: 'a',
      value: ['1'],
      inputt: '',
      tupian: '',
      biaoti: '',
      laoshi: '',
      youxiaoqi: '',
      zhuangtai: '',
      jine: '',
      renshu: '',
      jieshao: '',
      neirong: '',
      listsp: [],
      statuse: '',
      pjlists: [],
      typess: '',
      yp: [],
      yuanjia: '',
      tp: [],
      gc: [],
      givesize: "",
      recorder: {},
      recorder_status: "录音",
      stop_status: "结束",
      notCommit: true,   //能否提交
      recoding: false,   //是否正在录音
      show: false,       //是否显示遮罩层
      upfilename: "",     //上传录音的文件名
      score: 0         //唱完评分
    }
  },
  components: {
    ImagePreview
  },
  created() {

    this.activeName = this.$route.query.activeName ? this.$route.query.activeName : 'a'
    this.myrequest({
      url: "/client/getsign.action",
      types: "post",
      data: {},
      succ: (res) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appid, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature,// 必填，签名
          jsApiList: ['chooseImage', 'updateAppMessageShareData', 'updateTimelineShareData', 'chooseWXPay', "stopRecord", "startRecord"] // 必填，需要使用的JS接口列表
        });
      },
      errs: (msg) => {


      }
    })

    this.getdata()
  },
  methods: {
    imgPre(url) {
      ImagePreview([url]);
    },
    cancle() {
      this.show = false;
    },
    update() {
      //确认文件名
      if (this.upfilename == "") {
        Toast("请输入标题");
        return false;
      }

      let that = this;
      this.stop_status = "上传中..."
      let fileSize = this.recorder.fileSize;//录音总大小
      // let PCMBlob = recorder.getPCMBlob();//获取 PCM 数据
      // let wav = recorder.getWAVBlob();//获取 WAV 数据
      // let channel = recorder.getChannelData();//获取左声道和右声道音频数据
      let toltime = this.recorder.duration;//录音总时长
      console.log("文件大小：", fileSize, "总时长：" + toltime);


      let file = this.convertToMp3(this.recorder.getWAV());

      file = new File([file], this.upfilename + '.mp3');

      console.log("文件对象：", file);

      const datas = new FormData();

      datas.append("file", file);
      axios({
        url: "https://api.fuyueopera.com/updatafile.action",
        method: "post",
        headers: {
          //;boundary=----WebKitFormBoundaryFJdWuYqSbbdzsuiVnpm
          'Content-Type': 'multipart/form-data'
        },
        data: datas

      }).then(
          (res) => {
            console.log("拿到的网络路径：", res.data.url);
            this.myrequest({
              url: '/client/upusersingalong.action',
              types: 'post',
              data: {
                // token:this.$store.state.token
                cid: this.$route.query.id,
                titles: this.upfilename,
                url: res.data.url
              },
              succ: (res) => {
                console.log("上传结果：", res)

                that.stop_status = "结束";
                this.show = false;
                Toast.success("发布成功");
                this.getdata();
              },
              errs: (msg) => {
                Toast.fail("上传失败");
              }
            })
          }
      ).catch(
          (err) => {
            console.log("上传失败错误信息为：" + err);
          }
      )
    },
    start() {
      let that = this;
      this.recorder = new Recorder();
      this.recorder.start();
      // console.log(recorder);
      this.recorder_status = "录音中..."
      Toast("开始录音");
      this.notCommit = false;
    },
    stop() {

      console.log("详情页的课程id:", this.$route.query.id);
      if (this.notCommit) {
        Toast("尚未开始录音");
      } else {
        this.show = true;
        this.recorder.stop();
        this.recorder_status = "录音"
        this.notCommit = true;
        this.score = parseInt(Math.random() * 30) + 70;

        // this.upfilename= encodeURIComponent('audio_recording_' + new Date().getTime());
      }
    },
    convertToMp3(wavDataView) {
      const lamejs = require('lamejs');
      // 获取wav头信息
      const wav = lamejs.WavHeader.readHeader(wavDataView); // 此处其实可以不用去读wav头信息，毕竟有对应的config配置
      const {channels, sampleRate} = wav;
      console.log('wav', wav)
      const mp3enc = new lamejs.Mp3Encoder(channels, sampleRate, 128);
      // 获取左右通道数据
      const result = this.recorder.getChannelData()
      const buffer = [];

      const leftData = result.left && new Int16Array(result.left.buffer, 0, result.left.byteLength / 2);
      const rightData = result.right && new Int16Array(result.right.buffer, 0, result.right.byteLength / 2);
      const remaining = leftData.length + (rightData ? rightData.length : 0);

      const maxSamples = 1152;
      for (let i = 0; i < remaining; i += maxSamples) {
        const left = leftData.subarray(i, i + maxSamples);
        let right = null;
        let mp3buf = null;
        if (channels === 2) {
          right = rightData.subarray(i, i + maxSamples);
          mp3buf = mp3enc.encodeBuffer(left, right);
        } else {
          mp3buf = mp3enc.encodeBuffer(left);
        }
        if (mp3buf.length > 0) {
          buffer.push(mp3buf);
        }
      }

      const enc = mp3enc.flush();

      if (enc.length > 0) {
        buffer.push(enc);
      }

      return new Blob(buffer, {type: 'audio/mp3'});
    }
    ,
    yinping(item, code) {
      //code   gc=去跟唱页面  code=yp 去音频页面
      //伴奏
      console.log(item);
      console.log(code);

      this.$router.push({path: '/yinpin', query: {id: this.$route.query.id,code:code}})
      // if (item.ivs == 1) {
      //   this.$router.push({path: '/yinpin', query: {id: item.id}})
      // } else if (this.statuse == 1) {
      //   this.$router.push({path: '/yinpin', query: {id: item.id}})
      // }
    },
    tpimg(item) {
      ImagePreview([item]);
    },
    shiping(item) {
      if (item.ivs == 1) {
        this.$router.push({path: '/bofang', query: {id: item.id}})
      } else if (this.statuse == 1) {
        this.$router.push({path: '/bofang', query: {id: item.id}})
      }
    },
    goumai() {
      this.$router.push({path: '/Place'})
    },
    /*          点赞*/
    praise() {
      this.myrequest({
        url: '/client/addgiveuserinfo.action',
        types: 'post',
        data: {
          // token:this.$store.state.token
          cid: this.$route.query.id
        },
        succ: (res) => {
          Toast.success(res.msg);
          this.givesize = !this.givesize
          /*this.$router.go(-1)*/
        },
        errs: (msg) => {

        }
      })
    },
    /*          打赏*/
    reward() {

    },

    onClickIcon() {
      this.myrequest({
        url: '/client/addcollection.action',
        types: 'post',
        data: {
          // token:this.$store.state.token
          cid: this.$route.query.id
        },
        succ: (res) => {
          Toast.success('收藏成功');
          /*this.$router.go(-1)*/
        },
        errs: (msg) => {

        }
      })
    },
    onClickButton(item) {
      this.$router.push({path: '/purchase', query: {id: this.$route.query.id}})
    },
    getdata() {
      let that=this;
      this.myrequest({
        url: '/client/getcurriculuminfo.action',
        types: 'get',
        data: {
          // token:this.$store.state.token
          id: this.$route.query.id
        },
        succ: (res) => {
          console.log(res);
          this.bzlist=res.bzlist;
          this.tupian = res.data.covermap;
          console.log(this.tupian);
          this.biaoti = res.data.titles
          this.laoshi = res.data.teacher
          this.youxiaoqi = res.data.effectivetime
          this.zhuangtai = res.data.types
          this.jine = res.data.fee
          this.renshu = res.data.buynum
          this.jieshao = res.data.introduce
          this.neirong = res.data.content
          this.listsp = res.splist
          this.pjlists = res.pjlisr
          this.statuse = res.orderstatus
          this.yp = res.yplist
          this.yuanjia = res.data.price
          this.tp = res.imglist
          this.gc = res.mygclist
          this.givesize = res.givesize

          //图片缺失测试
          // this.tp[1].url="";
          console.log(this.tp);
        },
        errs: (msg) => {

        }
      })
    }
  },

}
</script>

<style lang="stylus" scoped>
.wrapper {
  position relative;
  width: 90vw;
  height 400px;
  margin-top: 5vw;
  transform: translateX(5vw);
  background-color: white;
  border-radius 4px;
  padding 20px;
  position: relative;

  #bgi {
    position absolute
    width: 61%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  li {
    font-size: 1.2rem;

    input {
      width: 60%;
      border: none;
      border-bottom: 1px solid #666666;
    }
  }

  .score {
    width: 50%;
    height: 40%;
    position absolute
    left: 50%;
    top: 50%;
    text-align center
    transform: translate(-50%, -50%);
    z-index: 2;
    font-size: 5vw;
    padding-top: 5vh;
    line-height: 5vh;
    color #bd1d06

    img {
      width: 10vw;
    }
  }

  .button {
    position: absolute !important;
    bottom: 0px;
  }
}

.disabled {
  color: #2B2C2D !important;
}

.bank_body {
  width 100%;
  position relative;

  .cancommit {

    color: #bd1d06;
  }

  .button {
    //
    position relative;
    width: calc(100% - 32px);
    height 50px;
    background-color #ffffff;
    box-shadow: 1px 1px 26px rgba(0,0,0,0.3);
    margin: 0 auto;
    margin-top 20px;
    border-radius 8px;
    margin-bottom 20px;
    display flex;
    justify-content space-around

    span {
      padding-top 12px
      font-size: 16px;
      color: #bd1d06;
      cursor: pointer;

      img {
        vertical-align: middle;
      }
    }

    .start {
      img {
        width: 17px;
      }
    }

    .stop {
      img {
        width: 27px;
      }
    }

    .line {
      width: 1px;
      height 30px;
      position absolute;
      background-color gray
      left: 50%;
      top: 10px;
    }
  }

  .kechengxiangqing {
    width 95%;
    margin 10px auto;

    dl {
      width 100%

      dt {
        font-size 12pt
        font-weight 500
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      dd {
        margin-left 0
      }

      dd:nth-of-type(1) {
        font-size 9pt
        color #666
        line-height 200%
      }

      dd:nth-of-type(2) {
        font-size 13pt
        color #e9353e

        span {
          font-size 9pt
        }
      }

      dd:nth-of-type(3) {
        font-size 9pt
        color #666
        line-height 200%
      }

      dd:nth-of-type(3) {
        margin-top 5px
        color #888
        font-size 10pt
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
    }

    .biaoti {
      font-weight 500;
      font-size 16px;
      color #333333;
      margin-left 10px;
    }

    .laoshi {
      font-weight 500;
      font-size 14px;
      color #ccc;
      margin-left 5px;
      margin-top 10px;
    }

    .cputong {
      font-weight 500;
      font-size 14px;
      color #ccc;
      margin-left 5px;
      margin-top 5px;
    }

    .xianshi {
      /*margin-left 5px;*/

      .xianshiname {
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 5px;
      }

      .youxiao {
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 5px;
      }

      .xianjia {
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 5px;
      }

      .suzhi {
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 5px;
      }

      .jieshi {
        font-weight 500;
        font-size 14px;
        color #ccc;
        margin-left 5px;
        margin-top 5px;
      }
    }
  }

  .foot {
    width 95%;
    margin auto;
    display flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position fixed;
    bottom 0px;

    .shuru {
      width 85%;
    }

    .anniu {
      width 10%;
    }
  }

  .tupian {
    width 100%;
    max-height 100vw
    overflow hidden

    img {
      width 100%;
      /*height 250px;*/
    }
  }

  .xiangqing {
    font-weight 500;
    font-size 16px;
    color #333333;
    width 90%;
    margin 10px auto;
  }

  .xi {
    width 90%;
    margin 10px auto;
    line-height 1.5
  }

  .xiangqingtu {
    width 90%;
    margin 0px auto;

    img {
      width 100%;
      display block
    }
  }

  .shiping {
    position relative;
    border-bottom: 1px solid rgb(245, 242, 242);
    padding: 10px 0px;

    >>> .van-collapse-item__content {
      padding 0px;
    }
    width 90%;
    margin 10px auto;
    display flex;

    .xiabiao {
      margin-right 10px;
    }

    .preview {
      width: 20%;
      display: flex;
      justify-content center;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .kecheng {

    }

    .bofang {

      position absolute;
      right 0px;

      display: block;
      width: 20px;
      height: 20px;
      cursor: pointer;

      img {
        width 20px;
        height 20px;
      }
    }
  }

  .pinglun {
    width 90%;
    margin 10px auto;
    display flex

    .touxiang {
      margin-top 10px;

      img {
        width 40px;
        height 40px;
        border-radius 30px;
      }
    }

    .neirong {
      margin-left 10px;

      .name {
        color #333333;
        font-size 14px;
        line-height 30px
        font-weight 500
      }

      .ping {
        margin-top 0px;
        color #444;
      }

      .shijian {
        /*margin-top 5px;*/
        color #ccc;
      }
    }
  }
}

/deep/ .van-collapse {
  border-bottom: 1px solid #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/ziyuanku/bank.vue